import { buildGtag } from '.';

export const addGTag = tag => {
  if (
    !!(
      typeof window !== 'undefined' &&
      window.document &&
      window.document.createElement &&
      window.dataLayer
    )
  ) {
    window.dataLayer.push(tag);
  }
};

export const handleGaLogout = gaEvents => customer => {
  const builtGtag = buildGtag({
    tagConfig: gaEvents.gaLogout,
    data: customer,
  });
  return builtGtag && addGTag(builtGtag);
};
export const handleGaSignIn = (gaEvents, data) => customer => {
  const builtGtag = buildGtag({ tagConfig: gaEvents.gaSignIn, data: { ...customer, ...data } });
  return builtGtag && addGTag(builtGtag);
};

export const handleGaSignUp = (gaEvents, data) => customer => {
  const builtGtag = buildGtag({ tagConfig: gaEvents.gaSignUp, data: { ...customer, ...data } });
  return builtGtag && addGTag(builtGtag);
};

export const handleGaNewOrder = gaEvents => customer => {
  const builtGtag = buildGtag({
    tagConfig: gaEvents.gaNewOrder,
    data: customer,
  });
  return builtGtag && addGTag(builtGtag);
};
